import { ticketDetailsShortcutMap, ticketsShortcutMap } from '../config/keyboardShortcuts';

/**
 * Maps action keys to their keyboard shortcuts (tickets list + ticket details)
 */
const actionToShortcutMap: Record<string, string> = {};

[ticketsShortcutMap, ticketDetailsShortcutMap].forEach(map => {
  map.shortcuts.forEach(shortcut => {
    if (shortcut.action) {
      actionToShortcutMap[shortcut.action] = shortcut.combo;
    }
  });
});

/**
 * Formats a tooltip title with its keyboard shortcut if available.
 * Matches WarrQueue format: "Title [ Ctrl+S ]"
 */
export function formatTooltipWithShortcut(title: string, actionKey?: string): string {
  if (!actionKey || !actionToShortcutMap[actionKey]) {
    return title;
  }

  const shortcut = actionToShortcutMap[actionKey];
  return `${title} [ ${shortcut} ]`;
}

/**
 * Gets the keyboard shortcut for an action
 */
export function getShortcutForAction(actionKey: string): string | undefined {
  return actionToShortcutMap[actionKey];
}
